/*
 * Entry point for the command runtime: wires the ribbon buttons to their
 * handlers.
 */

/* global Office, console */

import { attachAsZip } from "./attachAsZip";
import { zipAttachments } from "./zipAttachments";
import { setLanguage } from "../common/strings";

// The runtime dispatches a button click without first running Office.onReady,
// so the associations have to exist as soon as this script loads. Registering
// them inside onReady leaves both buttons doing nothing at all.
Office.actions.associate("zipAttachments", withLanguage(zipAttachments));
Office.actions.associate("attachAsZip", withLanguage(attachAsZip));

type CommandHandler = (event: Office.AddinCommands.Event) => Promise<void>;

/** Follows the Outlook UI language, not the language of the message. */
function withLanguage(handler: CommandHandler): CommandHandler {
  return (event) => {
    try {
      setLanguage(Office.context.displayLanguage);
    } catch {
      // The context isn't up yet on this host; the catalogue defaults to English.
    }
    return handler(event).catch((error: Error) => {
      // The handlers report through the notification bar, which is itself the
      // thing most likely to be missing. Nothing below this point can surface.
      console.error("[zip] command failed before it could report:", error);
      event.completed();
    });
  };
}
